import React from 'react';
import {
  Button,
  Dialog,
  DialogBody,
  DialogContent,
  DialogFooter,
  DialogHeader,
} from '@billda/design-system';

interface ResendOwnerInvitationDialogProps {
  open: boolean;
  email: string;
  organisationName: string;
  isLoading: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

export const ResendOwnerInvitationDialog: React.FC<
  ResendOwnerInvitationDialogProps
> = ({ open, email, organisationName, isLoading, onConfirm, onCancel }) => {
  return (
    <Dialog
      open={open}
      onOpenChange={nextOpen => {
        if (!nextOpen) {
          onCancel();
        }
      }}
    >
      <DialogContent
        aria-labelledby="resend-owner-invitation-dialog-title"
        aria-describedby="resend-owner-invitation-dialog-description"
      >
        <DialogHeader id="resend-owner-invitation-dialog-title">
          Resend owner invitation?
        </DialogHeader>
        <DialogBody id="resend-owner-invitation-dialog-description">
          <strong>{email}</strong> will receive a new invite link for{' '}
          <strong>{organisationName}</strong>, valid for 2 days. The previous
          link will stop working immediately.
        </DialogBody>
        <DialogFooter>
          <Button variant="ghost" onClick={onCancel} disabled={isLoading}>
            Cancel
          </Button>
          <Button
            variant="neutral"
            onClick={onConfirm}
            disabled={isLoading}
            loading={isLoading}
            data-testid="confirm-resend-owner-invitation-button"
          >
            {isLoading ? 'Sending...' : 'Resend invitation'}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
